import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  DateTimeFilter,
  GroupedSearchFilterFacet,
  SearchFilterFacet,
  SortOption,
} from '@savgroup-front-common/types';
import {
  ViewableColumnSubType,
  ViewableColumnType,
} from '@savgroup-front-common/types/SearchResultList';

const ENDPOINT = `${APIConfiguration.search}export/filteredUsers`;

export enum EXPORT_FORMAT {
  CSV = 'Csv',
  EXCEL = 'Excel',
}

export interface SelectedColumnForExport {
  key: string;
  columnType?: ViewableColumnType;
  columnSubType?: ViewableColumnSubType;
  children?: SelectedColumnForExport[];
  isSortable?: boolean;
  label?: string;
}

export interface ExportFilteredUsersCommandArgs {
  query?: string;
  exportFormat: EXPORT_FORMAT;
  filters?: SearchFilterFacet[];
  groupedFilters?: GroupedSearchFilterFacet[];
  sortOptions?: SortOption[];
  selectedColumns?: SelectedColumnForExport[];
  dateTimeFilters?: DateTimeFilter[];
  sellerId?: string;
  tenantId?: string;
}

async function exportFilteredUsersCommand({
  exportFormat,
  query,
  filters,
  groupedFilters,
  sortOptions,
  selectedColumns,
  dateTimeFilters,
  sellerId,
  tenantId,
}: ExportFilteredUsersCommandArgs): Promise<
  BackResponse<string> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<string>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        query,
        filters,
        groupedFilters,
        exportFormat,
        sortOptions,
        selectedColumns,
        dateTimeFilters,
        sellerId,
        tenantId,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default exportFilteredUsersCommand;
